//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CompareEmphasizeMode",1,0],[1,"DesignElementToCompare",0,"SelectNXObjectList",0]],[[[],"UpdateDisplay",{R_:{nPrevRenderingStyle:''}},0,0],[["singleparttorestore"],"RestoreDisplay",{},1,0]],[]];
SPLM.Features.ShipDesign.CompareModeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.CompareModeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.CompareModeBuilder.CompareMode = Object.freeze({
    "DesignMode" : "DesignMode", "ManufacturingMode" : "ManufacturingMode"});

export default SPLM;